module.exports = __webpack_public_path__ + "e2484dbdaa39cddeaa79396fedcc44e8.jpg";